
import CopyIcon from './Icons/CopyIcon.vue'
import TickIcon from './Icons/TickIcon.vue'
import LoadingIcon from './Icons/LoadingIcon.vue'

export default {
    name: "CopyButton",
    inject: ['isLogged', 'toast', 'fvAPI_CopySomething'],
    props: {
        item: [Object, String],
        type: {
            type: String,
            validator: val => ['page', 'section', 'history', 'future', 'link'].includes(val)
        }
    },
    components: {
        CopyIcon,
        TickIcon,
        LoadingIcon
    },
    data() {
        return {
            isLoading: false,
            isSuccess: null,
            isSuccessResetTimeOut: null
        }
    },
    beforeDestroy() {
        if (this.isSuccessResetTimeOut) {
            clearTimeout(this.isSuccessResetTimeOut)
        }
    },
    methods: {
        copy() {
            if (!this.isLogged) {
                this.toast(this.$t('ميزة النسخ تتطلب تسجيل الدخول'))
            }
            this.isLoading = true
            this.fvAPI_CopySomething({item: this.item, type: this.type})
                .then(() => this.setSuccess(true))
                .catch((e) => this.setSuccess(false))
                .finally(() => this.isLoading = false)
        },
        setSuccess(isSuccess) {
            if (this.isSuccessResetTimeOut) {
                clearTimeout(this.isSuccessResetTimeOut)
            }
            this.isSuccess = isSuccess
            this.isSuccessResetTimeOut = setTimeout(() => {
                this.isSuccess = null
            }, 3000)
        }
    }
}
